import Grid from '@mui/material/Grid2';

import { FooterLinkColumn } from '@/components/molecules';
import { type FooterColumn } from '@/config/navigation';

/**
 * The twelve columns of the grid, divided by however many link groups there
 * are, floored so four groups take three columns each and five take two.
 *
 * Derived rather than the fixed `4` this used to be. That constant was right
 * while there were exactly three groups and silently wrong the moment a
 * fourth was added: the fourth wrapped onto a second row at a third of the
 * width, beside two thirds of nothing. Dividing means the row stays full at
 * three groups and at four, and the day a fifth is added it is a layout
 * decision rather than a visual bug.
 */
const columnSpan = (count: number) => Math.max(1, Math.floor(12 / Math.max(1, count)));

/** The link groups, spread across one row from sm up and two across on phones. */
export function FooterLinks({ columns }: { columns: readonly FooterColumn[] }) {
  const span = columnSpan(columns.length);

  return (
    <Grid container spacing={{ xs: 10, sm: 8 }}>
      {columns.map((column) => (
        <Grid key={column.title} size={{ xs: 6, sm: span }}>
          <FooterLinkColumn column={column} />
        </Grid>
      ))}
    </Grid>
  );
}
